import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SurveyFormPage } from '@/pages/SurveyFormPage';
import { CountingPage } from '@/pages/CountingPage';
import { SummaryPage } from '@/pages/SummaryPage';
import { HistoryPage } from '@/pages/HistoryPage';
import { startAutoSync } from '@/services/syncService';

export function App() {
  useEffect(() => startAutoSync(), []);

  return (
    <BrowserRouter>
      <div className="app-shell">
        <Routes>
          <Route path="/" element={<SurveyFormPage />} />
          <Route path="/count/:surveyId" element={<CountingPage />} />
          <Route path="/summary/:surveyId" element={<SummaryPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
